import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToSection } from "@/lib/lenis";

export default function TrialCta() {
  return (
    <section
      data-testid="trial-section"
      className="border-t border-white/10 px-6 md:px-12 py-32 md:py-40 text-center"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-3xl mx-auto"
      >
        <p className="font-mono-accent text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B99AE] mb-8">
          Launch offer
        </p>
        <h2
          data-testid="trial-heading"
          className="font-serif-display font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none"
        >
          Try ROSTENO free for <span className="text-[#4ADE80]">14 days.</span>
        </h2>
        <p className="mt-8 text-sm sm:text-base leading-relaxed text-[#8B99AE] max-w-lg mx-auto">
          Every waitlist member gets a full two-week trial at launch — every
          feature, no card required.
        </p>
        <button
          data-testid="trial-claim-button"
          onClick={() => scrollToSection("#waitlist")}
          className="group mt-10 inline-flex items-center gap-3 font-mono-accent text-xs uppercase tracking-[0.2em] rounded-full bg-gradient-to-r from-[#34D399] to-[#38BDF8] text-black px-8 py-4 transition-opacity duration-300 hover:opacity-85"
        >
          Claim your trial
          <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </motion.div>
    </section>
  );
}
